import { format } from "date-fns";

const ReportTemplateHeader = (props) => {
  const { tableWidth, title } = props;
  const { start_date, end_date, data_product } = props.headerValue;

  return (
    <div className={`col-start-start ${tableWidth}`}>
      <div id="report-title" className="bg-zinc-500 p-3 w-full tracking-wide">
        <h1 className="text-white font-semibold">{title}</h1>
      </div>
      <div
        id="report-first-page"
        className="row-between-start text-sm py-4 w-full px-2"
      >
        <div className="col-start-start gap-1 flex-1 min-w-0">
          <div className="row-start-center gap-2">
            <span className="w-[5rem] text-right shrink-0"> Product: </span>
            <span className="font-semibold">{data_product?.name || "-"}</span>
          </div>
          <div className="row-start-center gap-2">
            <span className="w-[5rem] text-right shrink-0"> Periode: </span>
            <span className="font-semibold">
              {start_date ? format(start_date, "dd MMM yyyy") : "-"} S/D{" "}
              {end_date ? format(end_date, "dd MMM yyyy") : "-"}
            </span>
          </div>
        </div>
        <div className="col-start-start gap-1 shrink-0">
          <div className="row-start-center gap-2">
            <span className="w-[6rem] text-right"> Tanggal Print: </span>
            <span className="font-semibold">
              {format(new Date(), "dd MMM yyyy  HH:mm")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportTemplateHeader;
